function SettingsTab() {
  return (
    <div className="card animate-fade-in w-full mt-0">
      <h2 className="text-2xl font-semibold text-text-light dark:text-text-dark mb-4">App Settings</h2>
      <div className="flex flex-col gap-4">
        <p className="text-neutral">No settings available at this time.</p>
      </div>
    </div>
  );
}

export default SettingsTab;
